<script lang="ts" setup>
export interface ImageModalProps {
    src: string;
    alt?: string;
}

const props = withDefaults(defineProps<ImageModalProps>(), {
    src: "",
    alt: "Nothing defined",
});
</script>

<template>
    <div class="m-auto has-text-centered">
        <img :src="props.src" :alt="props.alt" class="m-auto" style="max-height: 75vh" />
    </div>
</template>
